// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__YC-Hq","title":"style_title__yfEnN","subtitle":"style_subtitle__7R61f","bottom_button":"style_bottom_button__PIgtg"};